import {toNumber} from './units';

/**
 * The participation build-up card (TrendLineCard, source participation_buildup)
 * sends one point per month with the *cumulative* number of learners by the
 * end of that month: `points: [{label: '2026-09', value: 600}]`. Months with no
 * new learner are left out, and a young dashboard has a single point — which a
 * line alone cannot show (QA, 9 Oct 2026). The chart therefore draws bars for
 * the learners added in each month and a line for the running total.
 *
 * `added` of the first point is its cumulative value (every learner to date is
 * new to the series); a dip in the cumulative figure clamps to 0 rather than a
 * negative bar.
 */
export const buildupSeries = (points) => {
    const rows = (points || [])
        .map((p) => ({label: String(p?.label ?? '').trim(), cumulative: toNumber(p?.value)}))
        .filter((p) => p.label && p.cumulative !== null)
        .sort((a, b) => a.label.localeCompare(b.label, undefined, {numeric: true}));
    let prev = 0;
    return rows.map((p, i) => {
        const cumulative = Math.trunc(p.cumulative);
        const added = i === 0 ? cumulative : Math.max(0, cumulative - prev);
        prev = cumulative;
        return {label: p.label, cumulative, added};
    });
};

/** "2026-09" → "Sep 2026" for the axis; anything else is shown as sent. */
export const monthLabel = (label) => {
    const m = /^(\d{4})-(\d{2})$/.exec(String(label || ''));
    if (!m) return label;
    const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const idx = Number(m[2]) - 1;
    return names[idx] ? `${names[idx]} ${m[1]}` : label;
};
